import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { FilterService, UIKitModule } from '@vendasta/uikit';

import { VaAddonListModule } from './addon-list/addon-list.module';
import { VaOrderFormModule } from './order-form/order-form.module';
import { VaPricingModule } from './pricing/pricing.module';
import { StencilsModule } from './stencils/stencils.module';
import { StoreCardModule } from './store-card.module';
import { StoreComponent } from './store.component';
import { StoreService } from './store.service';
import { StorefrontComponent } from './storefront/storefront.component';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BillingService } from '@galaxy/billing';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { CoreSharedModule } from '@vendasta/shared';
import baseTranslation from './assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from './shared/constants';

@NgModule({
  imports: [
    CommonModule,
    UIKitModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatProgressBarModule,
    StoreCardModule,
    VaOrderFormModule,
    StencilsModule,
    VaPricingModule,
    VaAddonListModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    CoreSharedModule,
  ],
  declarations: [StoreComponent, StorefrontComponent],
  providers: [StoreService, FilterService, BillingService],
  exports: [StoreComponent, StoreCardModule, VaOrderFormModule, StencilsModule, StorefrontComponent],
})
export class StoreModule {}
